import { generaLivello } from "./utility.js";
export default function terzoLivello(k) {
    k.scene("terzoLivello", () => {
        const LIVELLO = [
            "",
            "",
            "",
            "",
            "  $",
            "    $",
            "    == $",
            "       ==",
            "            =",
            " @      $$$$   ^^           >",
            " ===================  ==  ===",
        ];
        generaLivello(k, LIVELLO, "quartoLivello");
    });
}   